<template>
  <div id="panelContainer" class="panel-area-container">
      <a-tabs type="card" v-model="activeKey">
        <a-tab-pane key="1" tab="参数设置">
          <a-row v-if="type=='node'" type="flex" justify="center" align="middle">
            <a-form :form="node" class="form" layout="vertical">
              <a-form-item label="节点名称:">
                <a-tooltip placement="bottom" title="按Enter键修改节点内容">
                  <a-input
                    placeholder="请输入"
                    v-model="node.label"
                    :disabled="readonly"
                    @pressEnter="onLabelChange"
                  ></a-input>
                 </a-tooltip>
              </a-form-item>
              <a-form-item v-if="['Collect'].includes(node.jobType)" label="采集作业模板:">
                <a-tooltip title="选择采集作业模板, 并进入节点更改作业的详细信息">
                  <a-select placeholder="请选择" :disabled="readonly" v-model="node.jobCode" @change="onChangeJobCollect($event)">
                  <!-- <a-select placeholder="请选择" :disabled="readonly" v-model="node.jobCode"> -->
                    <a-select-option v-for="(item, k) of collectJobList" :key="k" :value="item.collectJobCode">{{ item.collectJobName }}</a-select-option>
                  </a-select>
                </a-tooltip>
              </a-form-item>
              <!-- <a-form-item v-else label="数据加工作业:">
                <a-select placeholder="选择要关联的加工作业" :disabled="readonly" v-model="node.jobCode">
                  <a-select-option v-for="(item, k) of jobProcessList" :key="k" :value="item.processJobCode">{{ item.processJobName }}</a-select-option>
                </a-select>
              </a-form-item> -->
            </a-form>
          </a-row>

          <a-row v-if="type=='grid'" type="flex" justify="center" align="middle">
            <a-form :form="jobForm" class="form" layout="vertical">
              <a-form-item label="任务名称:" class="required">
                  <a-input
                    placeholder="请输入"
                    v-model="jobFlowInfo.flowName"
                    :disabled="readonly"
                  ></a-input>
              </a-form-item>
              <a-form-item label="任务编码:" class="required">
                  <a-input
                    clearable
                    placeholder="请输入"
                    v-model="jobFlowInfo.flowCode"
                    :disabled="readonly"
                  ></a-input>
              </a-form-item>
              <a-form-item label="任务描述:" >
                  <a-input
                    clearable
                    placeholder="请输入"
                    v-model="jobFlowInfo.flowDesc"
                    :disabled="readonly"
                  ></a-input>
              </a-form-item>
              <a-form-item label="是否启动:" class="required">
                  <k-switch v-model="jobFlowInfo.status" :disabled="readonly" />
              </a-form-item>
            </a-form>
          </a-row>
          <div
            :style="{
                  position: 'relative',
                  right: 0,
                  bottom: 0,
                  width: '100%',
                  borderTop: '1px solid #e9e9e9',
                  padding: '10px 16px',
                  background: '#fff',
                  textAlign: 'right',
                  zIndex: 1,
                }"
              >
                <a-button type="primary" v-if="type=='grid'" :disabled="readonly" @click="submit">保存</a-button>
                <!-- <a-button type="primary" v-else-if="type=='node' && ['Collect'].includes(node.jobType)" class="mgr20" :disabled="readonly" @click="enter">更新节点</a-button> -->
                <a-button type="primary" v-if="type=='node'" @click="enter">进入节点</a-button>
          </div>
        </a-tab-pane>
        
      </a-tabs>
  </div>
</template>

<script>
import { duration } from 'moment';
import { updateNode } from "../common";
import { CustomEventTypeEnum } from "../common/enums";
import { Channel } from "../common/transmit";

// 可操作区域
export default {
  props: ["type", "graph", "node", "jobFlowInfo", "collectJobList", "readonly"],
  data() {
    return {
      nodeForm: {
        label: "",
        jobCode: "",
        jobType: "",
      },
      jobForm: {
        name : "",
        code: "",
        desc: "",
        status: 0
      },
      activeKey: "1",
    };
  },
  methods: {
    onLabelChange() {
      this.nodeForm.label = this.node.label
      updateNode(this.nodeForm)
    },
    onChangeJobCollect(e) {
      let item = this.collectJobList.find(s => s.collectJobCode === e)
      if (item) {
        this.nodeForm.jobCode = item.collectJobCode
        this.nodeForm.label = item.collectJobName
        this.nodeForm.jobType = 'Collect'
        updateNode(this.nodeForm)
        this.node.jobCode = item.collectJobCode
        this.node.label = item.collectJobName
        this.node.jobType = 'Collect'
      }
    },
    change() {
      let item = this.collectJobList.find(s => s.collectJobCode === this.node.jobCode)
      if (item) {
        this.nodeForm.jobCode = item.collectJobCode
        this.nodeForm.label = item.collectJobName
        this.nodeForm.jobType = 'Collect'
        Channel.dispatchEvent(CustomEventTypeEnum.JOB_LINK, this.nodeForm)
      }
    },
    submit() {
      this.jobForm = {
        name : this.jobFlowInfo.flowName,
        code: this.jobFlowInfo.flowCode,
        desc: this.jobFlowInfo.flowDesc,
        status: this.jobFlowInfo.status
      }
      Channel.dispatchEvent(CustomEventTypeEnum.FLOW_SUBMIT, this.jobForm)
    },
    enter() {
      const edges = this.graph.getEdges()
      let sourceId = '';
      for (const edge of edges) {
        if (edge.target.cell === this.node.nodeId) {
          sourceId = edge.source.cell
          break;
        }
      }
      Channel.dispatchEvent(CustomEventTypeEnum.DOUBLE_NODE_CLICK, {...this.node, parentNodeId:sourceId})
    },
    remove() {
      Channel.dispatchEvent(CustomEventTypeEnum.NODE_REMOVE, this.node)
    }
  },
  
};
</script>

<style lang="scss" scoped>
@import "../styles/mixins.scss";

.panel-area-container {
  height: 100%;
  right: 0;
  top: 0;
  z-index: 2;
  width: 260px;
  min-width: 260px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background-color: #fff;
}

#panelContainer :global(.ant-tabs-bar) {
  padding: 0;
}

</style>
